export default __webpack_public_path__ + "static/media/main_pronunciation.88ec1941.png";